import { GeoMap, LatLng, OverlayView, Point } from '@@/bits/map'

function divOffset(originalDiv: HTMLDivElement): { x: number; y: number } {
  const offset = { x: 0, y: 0 }
  let div: HTMLElement = originalDiv
  do {
    offset.x += div.offsetLeft
    offset.y += div.offsetTop
    div = div.offsetParent as HTMLElement
  } while (div)
  return offset
}

export default class DropOverlay extends OverlayView {
  private map: GeoMap

  public constructor(map: GeoMap) {
    super()
    this.map = map
    this.setMap(map)
  }

  public onAdd = (): void => {}
  public onRemove = (): void => {}
  public draw = (): void => {}

  public fromPixelToLatLng(x: number, y: number): LatLng {
    var offset = divOffset(this.map.getDiv() as HTMLDivElement)
    return this.getProjection().fromContainerPixelToLatLng(new Point(x - offset.x, y - offset.y))
  }
}
